<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Constants
	import { PromotionsType, PromotionsTypeNames } from '@/Constants/Promotions.js';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Partials
	import BaseCreateCampaign from '@/Partials/Campaigns/_BaseCreateCampaign.svelte';
	import DepositMatchAudience from '@/Partials/Campaigns/Audience/DepositMatch.svelte';
	import DepositMatchOffer from '@/Partials/Campaigns/Offer/DepositMatch.svelte';
	// Stores
	import CampaignStore from '@/Stores/CampaignStore.js';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Utils
	import { prepareCampaignPayload, performCampaignRulesCheck } from '@/Partials/Campaigns/_Utils.js';

	export let type;
	export let open = false;
	export let approval_managers = [];
	export let account_managers = [];

	const dispatch = createEventDispatcher();

	let campaign = {};

	let default_campaign = {
		campaign_type_id: type,
		name: null,
		repeat_type_id: null,
		publish_date: null,
		end_date: null,
		time_to_start: null,
		expires_in: null,
		expires_in_unit_id: null,
		user_criteria: {},
		offer_rules: {},
		comms: [],
		is_draft: false,
		refresh_user_list: true,
		approved_by: null
	};

	campaign = Object.assign({}, default_campaign, campaign);

	let errors = {};

	function createCampaign(event) {
		errors = {};
		//clone the current campaign payload
		const campaignPayload = JSON.parse(JSON.stringify(campaign));
		campaignPayload.is_draft = event.submitter.name === 'saveAsDraft';

		const ruleCheckResult = performCampaignRulesCheck(campaignPayload);
		if (ruleCheckResult !== true) {
			errors = ruleCheckResult;
			return false;
		}

		CampaignStore.createCampaign(prepareCampaignPayload(campaignPayload))
			.then(() => {
				notify({
					type: 'success',
					title: 'Campaign created',
					message: 'Campaign successfully created!',
					timeout: 3
				});
				dispatch('created');
				open = false;
				campaign = Object.assign({}, default_campaign);
			})
			.catch((e) => {
				errors = e;
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Problem creating campaign',
					timeout: 3
				});
			});
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)} className="md:w-4/5 mx-2 md:mx-auto mt-6">
		<h2 slot="header" class="text-xl font-bold text-center">
			Create new {PromotionsTypeNames[type].toString().toLowerCase()} campaign
		</h2>
		<hr class="my-1" />
		<form on:submit|preventDefault={createCampaign}>
			<h1 class="font-semibold text-xl">Campaign Details</h1>
			<BaseCreateCampaign bind:campaign {errors} {approval_managers} />
			<hr class="mt-2 mb-2" />
			<h1 class="font-semibold text-xl">Audience</h1>
			{#if type === PromotionsType.NextDepositMatch}
				<DepositMatchAudience bind:user_criteria={campaign.user_criteria} {account_managers} {errors} />
			{/if}
			<hr class="mb-2" />
			<h1 class="font-semibold text-xl">Offer details</h1>
			{#if type === PromotionsType.NextDepositMatch}
				<DepositMatchOffer bind:offer_rules={campaign.offer_rules} {errors} />
			{/if}
			<hr />
			<div class="flex flex-row w-full px-4 text-left my-3 space-x-4 justify-end">
				<LoadingButton
					name="saveAsDraft"
					className="btn btn-black flex justify-center items-center bg-black px-4 ml-4"
					type="submit"
					>Save as draft
				</LoadingButton>
				<LoadingButton className="btn btn-black flex justify-center items-center bg-secondary px-4 ml-4" type="submit"
					>Publish
				</LoadingButton>
			</div>
		</form>
	</Modal>
{/if}
